import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupComponent } from '../popup/popup.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-file-viewer',
  standalone: true,
  imports: [CommonModule, PopupComponent],
  templateUrl: './file-viewer.component.html',
  styleUrls: ['./file-viewer.component.scss'],
})
export class FileViewerComponent implements OnChanges {
  @Input() fileUrl = '';
  @Input() fileName = '';
  @Input() showViewer = false;

  @Output() closeViewer = new EventEmitter<void>();
  @Output() downloadFile = new EventEmitter<void>();

  safeFileUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer) {}

  get isPreviewUnsupported(): boolean {
    if (!this.fileName) return false;
    const ext = this.fileName.split('.').pop()?.toLowerCase();
    return [
      'doc',
      'docx',
      'docm',
      'xls',
      'xlsx',
      'xlsm',
      'xlam',
      'ppt',
      'pptx',
      'pptm',
      'csv',
      'zip',
    ].includes(ext || '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showViewer'] || changes['fileUrl']) {
      if (this.showViewer && this.fileUrl) {
        this.safeFileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
          this.fileUrl,
        );
      } else {
        this.safeFileUrl = null;
      }
    }
  }

  onClose() {
    this.safeFileUrl = null;
    this.closeViewer.emit();
  }

  onDownload() {
    this.downloadFile.emit();
  }
}
